import { useEffect, useRef } from 'react'

export const useTimers = () => {
  const timersRef = useRef<Record<string, NodeJS.Timeout>>({})

  const setTimer = (key: string, callback: () => void, delay: number) => {
    clearTimer(key)
    timersRef.current[key] = setTimeout(callback, delay)
  }

  const clearTimer = (key: string) => {
    if (timersRef.current[key]) {
      clearTimeout(timersRef.current[key])
      delete timersRef.current[key]
    }
  }

  const clearAllTimers = () => {
    Object.keys(timersRef.current).forEach(clearTimer)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: On unmount only
  useEffect(() => {
    return () => clearAllTimers()
  }, [])

  return {
    setTimer,
    clearTimer,
  }
}
